<div class="form-group">
  <dx-data-grid biz-grid
    [dataSource]='partnerIdentifications'
    (onInitNewRow)="initNewIdentificationRow($event)"
    (onRowRemoving)="removeIdentificationRow($event)"
    (onRowUpdating)="handleIdentificationSave($event, false)"
    (onRowInserting)="handleIdentificationSave($event, true)">

    <dxo-editing mode="row"
      [allowUpdating]="allowUpdating"
      [allowAdding]="allowAdding"
      [allowDeleting]="allowDeleting">
    </dxo-editing>

    <dxi-column
      dataField="IdentificationType" cellTemplate="identificationTemplate" caption="Identification type"
      sortOrder="asc" dataType="string" calculateDisplayValue="IdentificationType.Name"
      [validationRules]="[{ type: 'required' }]"
      [calculateFilterExpression]="calculateFilterExpression">
      <dxo-header-filter [dataSource]="getIdentificationTypeHeaderFilterData()"></dxo-header-filter>
    </dxi-column>

    <dxi-column dataField="Value" caption="ID" dataType="string" [validationRules]="[{ type: 'required' }]"></dxi-column>
    <dxi-column dataField="IsMainIdentification" caption="Default" dataType="boolean"></dxi-column>
    <dxi-column dataField="Description" caption="Description" dataType="string"></dxi-column>

    <div *dxTemplate="let cell of 'identificationTemplate'">
      @if (cell.data.IdentificationType) {
        <span>{{cell.data.IdentificationType?.Name}}</span>
      }
      @if (!cell.data.IdentificationType) {
        <span style="color: red;">!! Identification type not found !!</span>
      }
    </div>
  </dx-data-grid>
</div>
